/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function() {
	var $win = jQuery(window),
		$body = jQuery('body');

		// jQuery(function(){jQuery('a[href^="#"]').click(function(){var target=jQuery(this).attr('href');jQuery('html, body').animate({scrollTop:jQuery(target).offset().top},800); if(window.outerWidth < 425){jQuery(".hide-for-desktop, .off-canvas-content").trigger("click");}});});


		// jQuery('#terms').css("font-size", 11 + "px");

		var s,
		spanizeLetters = {
		  settings: {
			letters: jQuery('.main-home .section-header h2'),
		  },
		  init: function() {
			s = this.settings;
			this.bindEvents();
		  },
		  bindEvents: function(){
			s.letters.html(function (i, el) {
			  //spanizeLetters.joinChars();
			  var spanizer = jQuery.trim(el).split("");
			  return '<span>' + spanizer.join('</span><span>') + '</span>';
			});
		  },
		};

		spanizeLetters.init();

		var a,
		spanizeLetters2 = {
		  settings: {
			letters: jQuery('.main-home2 .section-header h2'),
		  },
		  init: function() {
			a = this.settings;
			this.bindEvents();
		  },
		  bindEvents: function(){
			a.letters.html(function (i, el) {
			  //spanizeLetters.joinChars();
			  var spanizer = jQuery.trim(el).split("");
			  return '<span>' + spanizer.join('</span><span>') + '</span>';
			});
		  },
		};

		spanizeLetters2.init();



	

	// var containerDiv = '<div class="form-inputs"></div>';	
	// jQuery(containerDiv).insertBefore('.ae-cform-item-email');
	// jQuery('.ae-cform-item-email').appendTo('.form-inputs');
	// jQuery('.ae-cform-item-country').appendTo('.form-inputs');

	jQuery('.ae-cform-optins-container').insertBefore('.ae-cform-item-submit-button');
	jQuery('.form-policy').insertBefore('.ae-cform-item-submit-button');

	jQuery("#ae-cform-input-reg-email-1").attr("placeholder", "email");
	jQuery("#ae-cform-input-reg-country-1").attr("placeholder", "country")

	// Remove empty P tags created by WP inside of Accordion and Orbit
	jQuery('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
		  jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
		  jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});
	// jQuery(window).on('load', function() {
		jQuery('#ae-cform-input-reg-email-1').attr('placeholder', 'Email');

		jQuery('.top-bar .menu-bars').on('click', function() {
			jQuery(this).find('.fas').toggleClass('fa-times');
		});
		jQuery('.js-off-canvas-overlay').on('click', function() {
			jQuery('.top-bar .menu-bars .fas').removeClass('fa-times');
		});

		jQuery('.js-subscribe a').on('click', function(e) {
			e.preventDefault();

			var $target = jQuery(this).attr('href');

			jQuery('html, body').animate({
				scrollTop: jQuery($target).offset().top
			}, 800);

			if ( jQuery(this).parents('.off-canvas') ) {
				jQuery('.js-off-canvas-overlay').trigger('click');
			}
		});
		

		// if( $body.hasClass('home') ) {
			var $banner = jQuery('.js-banner'),
				$videos = jQuery('.js-video-list'),
				$releases = jQuery('.js-release-list'),
				$menu = jQuery('#main-nav li a');

			// $menu.on('click', function(e) {
			// 	var $title = jQuery(this).attr('title').toLowerCase();

			// 	if($title) {
			// 		e.preventDefault();

			// 		jQuery('.menu-primary li').removeClass('active');
			// 		jQuery(this).parent().addClass('active');

			// 		jQuery('html, body').animate({
			// 			scrollTop: jQuery('.section-'+$title).offset().top - 64
			// 		}, 800);
			// 	}
			// });
			
			$banner.slick({
				dots: true,
				fade: true,
				cssEase: 'linear',
				responsive: [
				  {
					breakpoint: 815,
					settings: {
						arrows: false
					}
				  }
				]
			});

			jQuery('.section-banner').addClass('init');

            $banner.on('beforeChange', function(event, slick, currentSlide, nextSlide){
              $banner.addClass('is-sliding');
            });
      
            $banner.on('afterChange', function(event, slick, currentSlide){
              $banner.removeClass('is-sliding');
            });

			$releases.slick({
				asNavFor: '.album-cover-list'
			});

			jQuery('.album-cover-list').slick({
				arrows: false,
				dots: false,
				fade: true,
				cssEase: 'linear',
				asNavFor: '.js-release-list',
				focusOnSelect: true
			});

            $releases.on('afterChange', function(event, slick, currentSlide){
              $releases.addClass('slided');
            });

			$videos.slick({
				dots: false,
				// fade: true,
				cssEase: 'linear',
				slidesToShow: 2,
				slidesToScroll: 1,
				responsive: [
					{
					  breakpoint: 815,
					  settings: {
						  slidesToShow: 1
					  }
					}
				  ]
			});
      
            $videos.on('afterChange', function(event, slick, currentSlide){
              $videos.addClass('slided');
            });


			jQuery('.article-video .button-yt').on('click', function(e) {
				e.preventDefault();
		
				var youtubeID = jQuery(this).data('id'),
					embedCode = "<div class='media-youtube-video'><iframe src='https://www.youtube.com/embed/" + youtubeID + "?showinfo=0&autohide=1&rel=0&autoplay=1&wmode=transparent' frameborder='0' allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture' allowfullscreen></iframe></div>",
					$parent = jQuery(this).parents('.type-video');
					
				if (!document.querySelector('.media-youtube-video')) {
					$parent.addClass('playing');
					$parent.append(embedCode);
					jQuery('.js-video-list').addClass('has-embed');
				} else {
					$parent.removeClass('playing');
					jQuery('.media-youtube-video').remove();
					jQuery('.js-video-list').removeClass('has-embed');
				}
			});
			jQuery('.js-video-list > button').on('click', function(){
				if (jQuery('.article-video').hasClass('playing')) {
					jQuery('.media-youtube-video').remove();
					jQuery('.article-video').removeClass('playing');
					jQuery('.js-video-list').removeClass('has-embed');
				}
			});

			jQuery('.js-intro-arrow').on('click', function(e){
				e.preventDefault();

				jQuery('html, body').animate({
					scrollTop: jQuery('.section-about').offset().top - 64
				}, 500);
			});

			jQuery('.main-home .section').each(function(){
				var self = jQuery(this);
			
				jQuery(this).waypoint({
					handler: function(direction) {
						// if(direction == 'down') {
						// }

						// jQuery('.main-home .section').removeClass('show');
						self.addClass('show');
					}, offset: '10%'
				});
			});


			jQuery('.main-home2 .section').each(function(){
				var self3 = jQuery(this);
			
				jQuery(this).waypoint({
					handler: function(direction) {
						// if(direction == 'down') {
						// }

						// jQuery('.main-home .section').removeClass('show');
						self3.addClass('show');
					}, offset: '10%'
				});
			});

			jQuery('.main-home .article-video').each(function(){
				var self = jQuery(this);
			
				jQuery(this).waypoint({
					handler: function(direction) {
						// if(direction == 'down') {
						// }

						// jQuery('.main-home .section').removeClass('show');
						self.addClass('animate');
					}, offset: '10%'
				});
			});


			jQuery('.main-home .section-header h2').each(function(){
				var self = jQuery(this);
			
				jQuery(this).waypoint({
					handler: function(direction) {
						// if(direction == 'down') {
						// }

						// jQuery('.main-home .section').removeClass('show');
						self.addClass('js-spanize');
					}, 
					offset: '50%'
				});
			});


			jQuery('.main-home2 .section-header h2').each(function(){
				var self2 = jQuery(this);
			
				jQuery(this).waypoint({
					handler: function(direction) {
						// if(direction == 'down') {
						// }

						// jQuery('.main-home .section').removeClass('show');
						self2.addClass('js-spanize');
					}, 
					offset: '50%'
				});
			});

			if( $win.width() < 480) {

				var waypoints = jQuery('.section-about').waypoint({
					handler: function(direction) {
					  if(direction == 'up') {
						jQuery('#top-bar-menu .logo').removeClass('show');
					  } else {
						jQuery('#top-bar-menu .logo').addClass('show');
					  }
					}, offset: '0'
				  });
			}
		// }

		initScrollMagic();
			  function initScrollMagic() {
				// requirejs(['//cache.umusic.com/_sites/_halo/libraries/scrollmagic/js/ScrollMagic.min.js'],
				//   function(ScrollMagic) {
					var body = jQuery("body");
			
					jQuery(".node--event").each(function(index) {
					  var controller = new ScrollMagic.Controller();
					  var currentEl = this;
			
					  var artistScene = new ScrollMagic.Scene({
						triggerElement: currentEl,
						offset: 0,
						triggerHook: .6,
						reverse: false
					  })
					  .setClassToggle(currentEl, 'animate-in')
					  .addTo(controller)
					  .on("enter", () => initGsapSectionEvent())
					});
			
					// if(body.hasClass("home")) {
			
					  jQuery(".article-video").each(function(index) {
						var controller = new ScrollMagic.Controller();
						var currentEl = this;
			
						var videoScene = new ScrollMagic.Scene({
						  triggerElement: currentEl,
						  offset: 0,
						  triggerHook: .6,
						  reverse: true
						})
						.setClassToggle(currentEl, 'animate-in')
						.addTo(controller)
						.on("enter", () => initGsapVideo())
					  });

					  jQuery(".umg_live_table tr").each(function(index) {
						var controller = new ScrollMagic.Controller();
						var currentEl = this;
			
						var videoScene = new ScrollMagic.Scene({
						  triggerElement: currentEl,
						  offset: 0,
						  triggerHook: .6,
						  reverse: true
						})
						.setClassToggle(currentEl, 'animate-in')
						.addTo(controller)
						.on("enter", () => initGsapTour())
					  });
			
					//   jQuery(".artists").each(function(index) {
					// 	var controller = new ScrollMagic.Controller();
					// 	var currentEl = this;
			
					// 	var videoScene = new ScrollMagic.Scene({
					// 	  triggerElement: currentEl,
					// 	  offset: 0,
					// 	  triggerHook: .6,
					// 	  reverse: true
					// 	})
					// 	.setClassToggle(currentEl, 'animate-in')
					// 	.addTo(controller)
					// 	.on("enter", () => initGsapRelease())
					//   });
					
				//   }); // End scrollmagic requirejs
				// }
			}

				// require.config({
				// 	packages: [
				// 	  {
				// 		name: 'gsap',
				// 		location: 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.3.1/',
				// 		main: 'gsap.min'
				// 	  }
				// 	],
				//   })
				

				// function initGsapTour() {
				// 	require(['gsap'],
				// 	function({gsap}) {
				// 	const tl = new gsap.timeline();   
					
				// 	tl.addLabel('start'); 
					
				// 	tl2.to(".umg_live_table tr", 1 , { 
				// 		opacity : 1 , 
				// 		transform: 'translateY(0)', 
				// 		ease: 'power4.InOut', 
				// 		stagger : { amount : 1.5 } 
				// 	  } , 'start')
				//   })
				// }
				
				//   function initGsapRelease() {
				// 	// require(['gsap'],
				// 	// function({gsap}) {
				// 	const tl = new gsap.timeline();   
					
				// 	tl.addLabel('start'); 
					
				// 	// tl.to(".artists", 1 , { 
				// 	// 	opacity : 1 , 
				// 	// 	transform: 'translateY(0)', 
				// 	// 	ease: 'power4.InOut', 
				// 	// 	stagger : { amount : 1 } 
				// 	//   } , 'start')
				// //   }
				// }

				// function initGsapVideo() {
				// 	require(['gsap'],
				// 	function({gsap}) {
				// 	const tl = new gsap.timeline();   
					
				// 	tl.addLabel('start'); 
					
				// 	tl2.to(".article-video", 1 , { 
				// 		opacity : 1 , 
				// 		transform: 'translateY(0)', 
				// 		ease: 'power4.InOut', 
				// 		stagger : { amount : 1 } 
				// 	  } , 'start')
				//   })
				// }
								
				
	// });
}); 

var header = document.getElementsByClassName('fade')[0];

function fadeOutOnScroll(element) {
  if (!element) {
    return;
  }
  
  var distanceToTop = window.pageYOffset + element.getBoundingClientRect().top;
  var elementHeight = element.offsetHeight;
  var scrollTop = document.documentElement.scrollTop;
  
  var opacity = 1;
  
  if (scrollTop > distanceToTop) {
    opacity = 1 - (scrollTop - distanceToTop) / 230;
  }
  
  if (opacity >= 0) {
    element.style.opacity = opacity;
  }
}

function scrollHandler() {
  fadeOutOnScroll(header);
}

window.addEventListener('scroll', scrollHandler);

let anchorlinks = document.querySelectorAll('a[href^="#"]')
 
for (let item of anchorlinks) { // relitere 
    item.addEventListener('click', (e)=> {
        let hashval = item.getAttribute('href')
        let target = document.querySelector(hashval)
        target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        })
        history.pushState(null, null, hashval)
        e.preventDefault()
    })
}